// extracted by mini-css-extract-plugin
export var cartIcon = "_jr-0";
export var cartIconContainer = "_jr-1";